import { logger } from '../services/logger';
import { getCompileProviderAsync } from './ngProvider';
import { angularizeDirective } from './react-in-angularjs';

export const createLazyReactDirective = (
  factory: () => Promise<React.ComponentType>,
  name: string,
  propsSchema: { [key: string]: any } = {},
) => {
  getCompileProviderAsync()
    .then((app) => angularizeDirective(factory, name, app, propsSchema))
    .catch((error) =>
      logger.error(`Error building ${name} directive`, { error }),
    );

  return {
    name,
    htmlName: name.replace(/[A-Z]/g, (letter) => `-${letter.toLowerCase()}`),
  };
};
